import { createAsyncAction } from 'typesafe-actions';

import type { MciReport } from '@portal/api-models';

import { AnalyticsActionType } from './actionTypes';
import type {
  GetSupplySummariesRequestPayload,
  GetSupplySummariesResponsePayload,
} from './types';

export const mciReportUrlRequestAction = createAsyncAction(
  AnalyticsActionType.GET_MCI_REPORT_URL_REQUEST,
  AnalyticsActionType.GET_MCI_REPORT_URL_SUCCESS,
  AnalyticsActionType.GET_MCI_REPORT_URL_FAILURE
)<Pick<MciReport, 'objectKey' | 'subAccountUuid'>, string, Error>();

export const getSupplySummaryRequestAction = createAsyncAction(
  AnalyticsActionType.GET_SUPPLY_SUMMARIES_REQUEST,
  AnalyticsActionType.GET_SUPPLY_SUMMARIES_SUCCESS,
  AnalyticsActionType.GET_SUPPLY_SUMMARIES_FAILURE
)<GetSupplySummariesRequestPayload, GetSupplySummariesResponsePayload, Error>();
